import styled from "styled-components";

export const GoldContainer = styled.div`
  width: 100%;
  position: relative;

  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    top: 40px;
    left: 20px;
    width: calc(100% - 40px);
    box-sizing: border-box;
    height: calc(100% - 40px);
    border: 4px solid #a48559; /* Gold border */
    pointer-events: none; /* Ensures the border does not interfere with interactions */
    @media (max-width: 700px) {
      margin: 20px 0px;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  max-width: 1000px;

  display: flex;
  flex-direction: column;

  align-items: center;
  box-sizing: border-box;
`;
export const TextContainer = styled.div`
  padding: 40px 40px;
`;
export const FlexContainer = styled.div<{ $bgColor?: string; $color?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    font-family: Montserrat;
    font-weight: 500;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
  }
  h2 {
    font-family: Montserrat;
    font-weight: 500;
    text-transform: uppercase;
  }
  padding: 50px;

  background-color: ${({ $bgColor: color }) => color || "inherit"};
  color: ${({ $color: color }) => color || "inherit"};
  @media (max-width: 700px) {
    padding: 10px;
  }
`;
